import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    /// users:[]
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    /// users: state => state.user
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    /// GET_USERS(state,paylod){state.users = paylod}
  },
  actions: {
    //  getUsers(api,{commit}){
    //   this.$http.get(api).then((res)=>{
    //      commit('GET_USERS',res.data)
    //   })
    //  }
  },
}
// this.$store.dispatch('getUsers',api);
// import {mapGetters} from 'vuex'
// computed(){
//   ...mapGetters['users']
// }
